import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ICredential} from '../models/credential.model';
import {environment} from '../environments/environment';
import {User} from '../models/user.model';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  isAuth = false;

  constructor(private http: HttpClient) { }

  login(credential: ICredential) {
    return this.http.post<any>(`${environment.url}/auth/login/`, credential);
  }
  getUserByLogin(email: String) {
    return this.http.get<any>(`${environment.url}/user/email/` + email);
  }
  register(User: User) {
    return this.http.post<any>(`${environment.url}/auth/register`, User);
  }

  activate(User: User) {
    return this.http.post<any>(`${environment.url}/auth/activate`, User);
  }

  saveSession(json: { kapo_session_id: string; }): boolean {
    if (json.kapo_session_id !== undefined) {
      localStorage.setItem('kapo_session_id', json.kapo_session_id);
      return true;
    } else {
      return false;
    }
  }

  deleteSession() {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    localStorage.removeItem('kapo_session_id');
    return this.http.get(`${environment.url}/auth/invalidSession`, {'headers': headers});
  }

  getUSerBySessionId() {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/auth/connected`, {'headers': headers});
  }


  getUSerByKahpooSession(kapo_session_id: string) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + kapo_session_id);
    return this.http.get(`${environment.url}/auth/connected`, {'headers': headers});
  }


  isAuthenticated() {
      let headers = new HttpHeaders();
       headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
      return this.http.get<any>(`${environment.url}/auth/checkSession`, {'headers': headers});
  }

  saveEnvironement(env: string) {
    if (env === 'dev') {
      localStorage.setItem('env', env);
      environment.url = 'https://apidev.kahpoo.com/api';
    } else if (env === 'recette') {
      localStorage.setItem('env', env);
      environment.url = 'https://apirecette.kahpoo.com/api';
    } else if (env === 'qualification') {
      localStorage.setItem('env', env);
      environment.url = 'https://qualification.kahpoo.com/api';
    } else if (env === 'local') {
      localStorage.setItem('env', env);
      environment.url = 'http://localhost:8080/api';
    } else if (env === 'production') {
      localStorage.setItem('env', env);
      environment.url = 'https://www.kahpoo.com/api';
    }
  }

  checkSession(): boolean {
    if (localStorage.getItem('kapo_session_id') === null) {
      this.isAuth = false;
      return false;
    } else {
      this.isAuth = true;
      return true;
    }
  }

  getKapoSessionId(): string {
    return localStorage.getItem('kapo_session_id');
  }

  authenticated() {
    return localStorage.getItem('kapo_session_id') !== undefined;
  }

}
